<template>
  <div class="card-detail-page">
    <!-- Breadcrumb Navigation -->
    <nav class="breadcrumb">
      <span @click="navigateToPage('home')" class="breadcrumb-item">首頁</span>
      <span class="breadcrumb-separator">></span>
      <span v-if="tool?.工具大分類" @click="navigateToClass(tool.工具大分類)" class="breadcrumb-item">
        {{ tool.工具大分類 }}
      </span>
      <span v-if="tool?.工具大分類" class="breadcrumb-separator">></span>
      <span v-if="tool?.名稱" class="breadcrumb-item active">{{ tool.名稱 }}</span>
    </nav>

    <!-- Card Details -->
    <div class="card-detail" v-if="tool">
      <div class="header-section">
        <!-- Image Section -->
        <div class="image-wrapper">
          <img v-if="tool.Image" :src="tool.Image" alt="工具圖片" class="tool-image" />
        </div>
        <!-- Tool Header -->
        <div class="tool-header">
          <h1 class="tool-name">{{ tool.名稱 }}</h1>
          <div v-if="tool.推薦度" class="recommend-badge">
            <img src="/like.png" alt="推薦圖標" />
            <span>{{ tool.推薦度 }}</span>
          </div>
        </div>
      </div>

      <p class="tool-description">{{ tool.功能描述 }}</p>
      <div class="tool-tags">
        <span class="tool-tag" v-for="useCase in tool.relatedUseCases" :key="useCase">
          #{{ useCase }}
        </span>
      </div>

      <!-- Tool Details Table -->
      <!-- Tool Details Table -->
<table class="tool-details-table">
  <tbody>
    <tr>
      <td><strong>完整名稱</strong></td>
      <td>{{ tool.完整名稱 }}</td>
    </tr>
    <tr>
      <td><strong>所屬公司</strong></td>
      <td>{{ tool.所屬公司 }}</td>
    </tr>
    <tr>
      <td><strong>官方網址</strong></td>
      <td>
        <a v-if="tool.官方網址" :href="tool.官方網址" target="_blank" rel="noopener noreferrer">{{ tool.官方網址 }}</a>
      </td>
    </tr>
    <tr>
      <td><strong>入門指南</strong></td>
      <td>
        <div v-if="tool.入門指南?.length" class="startguide-list">
          <div v-for="(guide, index) in tool.入門指南" :key="index">
            <a :href="guide" target="_blank" rel="noopener noreferrer">{{ guide }}</a>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td><strong>工具大分類</strong></td>
      <td>{{ tool.工具大分類 }}</td>
    </tr>
    <tr>
      <td><strong>是否開源</strong></td>
      <td>{{ tool.是否開源 }}</td>
    </tr>
    <tr>
      <td><strong>語系</strong></td>
      <td>
        <span v-for="language in tool.語系" :key="language" class="tool-label">{{ language }}</span>
      </td>
    </tr>
    <tr>
      <td><strong>費用</strong></td>
      <td>
        <span v-for="cost in tool.費用" :key="cost" class="tool-label">{{ cost }}</span>
      </td>
    </tr>
    <tr>
      <td><strong>產品國籍</strong></td>
      <td>{{ tool.產品國籍 }}</td>
    </tr>
    <tr>
      <td><strong>程式語言</strong></td>
      <td>{{ tool.程式語言 }}</td>
    </tr>
    <tr>
      <td><strong>最新版本日期</strong></td>
      <td>{{ tool.最新版本日期 }}</td>
    </tr>
    <tr>
      <td><strong>風險評估</strong></td>
      <td>{{ tool.風險評估 }}</td>
    </tr>
    <tr>
      <td><strong>主題</strong></td>
      <td>{{ tool.主題 }}</td>
    </tr>
    <tr>
      <td><strong>使用說明</strong></td>
      <td>{{ tool.使用說明 }}</td>
    </tr>
    <tr>
      <td><strong>技術需求</strong></td>
      <td>{{ tool.技術需求 }}</td>
    </tr>
    <tr>
      <td><strong>使用模型</strong></td>
      <td>{{ tool.使用模型 }}</td>
    </tr>
    <tr>
      <td><strong>使用介面</strong></td>
      <td>{{ tool.使用介面 }}</td>
    </tr>
    <tr>
      <td><strong>上架時間</strong></td>
      <td>{{ tool.上架時間 }}</td>
    </tr>
  </tbody>
</table>

    </div>
    <div v-else>
      <p>未找到工具詳細資訊。</p>
    </div>
  </div>
</template>



<script>
import axios from "axios";

export default {
  name: "CardDetail",
  data() {
    return {
      tool: null, // 當前工具詳細資訊
    };
  },
  methods: {
    // 獲取工具詳細資訊
    async fetchToolDetails() {
      try {
        const baseUrlo = process.env.VUE_APP_SERVICE_URL;
        const baseUrl = process.env.VUE_APP_BASE_URL || `${baseUrlo}/api/v1`;
        const toolId = this.$route.params.id; // 透過路由參數獲取工具ID
        if (!toolId) {
          console.error("工具 ID 不存在，無法獲取詳細資訊。");
          return;
        }
        const response = await axios.get(`${baseUrl}/tools/${toolId}`);
        if (response.data.rtnCode === "0000") {
          this.tool = {
            ...response.data.data,
            relatedUseCases: response.data.data.relatedUseCases || [], // 標籤數據
          };
        } else {
          console.error("無法獲取工具資料:", response.data.rtnMsg);
        }
      } catch (error) {
        console.error("API 請求失敗:", error);
      }
    },
    // 導航至首頁
    navigateToPage(page) {
      if (page === "home") {
        this.$router.push({ name: "Home" });
      }
    },

    navigateToClass(classtype) {
    const routes = {
      "應用工具": "Applications",
      "開發工具": "Framework",
      "語言模型": "Model",
      // 添加更多分類和對應頁面
    };

    const targetPage = routes[classtype] || "Home"; // 預設跳轉至 Applications
    this.$router.push({ name: targetPage, query: { classtype } });
  },
  },
  mounted() {
    this.fetchToolDetails(); // 在組件掛載時加載工具詳細資訊
  },
};
</script>


<style scoped>
.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #555;
  margin-bottom: 0px; /* 與主內容分開 */
  padding: 30px 20px; /* 增加左右內邊距 */
  
 
}

.breadcrumb-item {
  cursor: pointer;
  color: #000;
  margin-right: 5px;
}


.breadcrumb-item.active {
  cursor: default;
  color: #246531;
  font-weight: bold;
}
.breadcrumb-separator {
  margin-right: 5px;
  color: #888;
}
.card-detail {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
}


.header-section {
  display: flex;
  align-items: center;
  gap: 20px; /* 保持左右間距 */
  margin-bottom: 20px; /* 增加下方的間距 */
}

.image-wrapper {
  flex: 0 0 150px;
  width: 150px;
  height: 150px;
  aspect-ratio: 1 / 1; /* 確保容器維持正方形比例 */
  border-radius: 8px; /* 與圖片一致的圓角 */
  overflow: hidden; /* 確保超出部分被裁切 */
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}


.tool-image {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 確保圖片按比例縮放，全部顯示 */
  object-position: center; /* 圖片居中對齊 */
  background-color: #f0f0f0; /* 預設背景色 */
  border-radius: 8px; /* 添加圓角 */
}



.tool-header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  position: relative;
}

.tool-name {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px; /* 增加與下方元素的間距 */
  line-height: 1.2;
}


.recommend-badge {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  background-color: transparent;
  color: #333;
  font-size: 16px;
  font-weight: bold;
}

.recommend-badge img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.tool-description {
  font-size: 16px;
  line-height: 1.8; /* 增加行高，讓文字更容易閱讀 */
  margin-top: 10px; /* 如果需要微調與圖片之間的距離 */
  margin-bottom: 20px; /* 與其他內容保持距離 */
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}


.tool-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px; /* 增加標籤之間的間距 */
  margin: 20px 0; /* 增加標籤區域與其他內容的距離 */
  padding: 0; /* 移除內邊距 */
  background-color: transparent; /* 移除背景色 */
  border: none; /* 確保沒有邊框 */
}


.tool-tag {
  padding: 6px 12px;
  background-color: #cee1fd; /* 保留標籤的背景色 */
  border-radius: 16px;
  font-size: 14px;
  color: #095bd2;
  word-break: break-word; /* 確保長字換行 */
  overflow-wrap: break-word;
  white-space: normal; /* 防止長字超出容器 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 添加陰影讓標籤更有層次感 */
}

.tool-details-table {
  width: 100%;
  table-layout: fixed; /* 固定表格寬度 */
  border-spacing: 0; /* 清除表格內部間距 */
  margin-top: 20px; /* 與上方內容保持間距 */
}

.tool-details-table td {
  padding: 10px;
  border: 1px solid #ddd;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.tool-details-table td:first-child {
  font-weight: bold;
  color: #333;
  width: 30%;
  background-color: #f9f9f9;
}


.tool-labels {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.tool-label {
  padding: 5px 10px;
  background-color: #eef1f6;
  border-radius: 4px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  color: #333;
}
</style>
